export type MapsLocation = {
  address: string;
  lat?: number | null;
  lng?: number | null;
};

function hasCoordinates(loc: MapsLocation): loc is MapsLocation & {
  lat: number;
  lng: number;
} {
  return loc.lat != null && loc.lng != null;
}

export function buildGoogleMapsUrl(loc: MapsLocation): string {
  if (hasCoordinates(loc)) {
    return `https://www.google.com/maps/search/?api=1&query=${loc.lat},${loc.lng}`;
  }
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(loc.address)}`;
}

export function buildWazeUrl(loc: MapsLocation): string {
  if (hasCoordinates(loc)) {
    return `https://waze.com/ul?ll=${loc.lat},${loc.lng}&navigate=yes`;
  }
  return `https://waze.com/ul?q=${encodeURIComponent(loc.address)}&navigate=yes`;
}

export function buildAppleMapsUrl(loc: MapsLocation): string {
  const query = encodeURIComponent(loc.address);
  if (hasCoordinates(loc)) {
    return `https://maps.apple.com/?ll=${loc.lat},${loc.lng}&q=${query}`;
  }
  return `https://maps.apple.com/?q=${query}`;
}

/** Abre o seletor de mapas do sistema (mobile) ou Google Maps (desktop). */
export function openPreferredMaps(loc: MapsLocation) {
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  if (isMobile) {
    const query = encodeURIComponent(loc.address);
    const geo = hasCoordinates(loc)
      ? `geo:${loc.lat},${loc.lng}?q=${query}`
      : `geo:0,0?q=${query}`;
    window.location.href = geo;
    return;
  }

  window.open(buildGoogleMapsUrl(loc), "_blank", "noopener,noreferrer");
}
